import { useEffect } from 'react';

import GroupChannelHandler from '@sendbird/uikit-react/handlers/GroupChannelHandler';
import useSendbirdStateContext from '@sendbird/uikit-react/useSendbirdStateContext';

import {
  channelsMetadata,
  MetaData,
  setChannelMetaData,
} from '@pharmaplan/common';

import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';

const uniqueId = 'groupHandler';

const useNewMetadata = () => {
  const dispatch = useAppDispatch();

  const store = useSendbirdStateContext();
  const sdk = store?.stores?.sdkStore?.sdk;

  const channelData = useAppSelector(channelsMetadata);

  useEffect(() => {
    const handleMetadataUpdate = (channel: any, metaData: MetaData) => {
      const { _url: inUrl } = channel ?? {};
      const inMeta = channelData?.[inUrl] ?? {};
      const updatedMeta = { ...inMeta, ...metaData };
      dispatch(setChannelMetaData({ ...channelData, [inUrl]: updatedMeta }));
    };

    const handler = new GroupChannelHandler({
      onMetaDataCreated: handleMetadataUpdate,
      onMetaDataUpdated: handleMetadataUpdate,
    });

    sdk?.groupChannel?.addGroupChannelHandler(uniqueId, handler);
    return () => {
      sdk?.groupChannel?.removeGroupChannelHandler(uniqueId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sdk, channelData]);
};

export default useNewMetadata;
